
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import SchedulePicker from "@/components/SchedulePicker.vue";
import LogTable from "@/components/logs/LogTable.vue";
import RelayBox from "@/components/relays/RelayBox.vue";
import RelayCreateOrEditBox from "@/components/relays/RelayCreateOrEditBox.vue";
import { Getter } from "vuex-class";
import RelayCreateMultiBox from "@/components/relays/RelayCreateMultiBox.vue";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiPlus, mdiQrcode } from "@mdi/js";
import debounce from "debounce";
import { canUseFeature } from "@/services/companies";
import SearchRow from "@/components/generic/search-row.vue";
import { getTokenLink } from "@/utils/misc";

@Component({
  components: {
    RelayBox,
    RelayCreateOrEditBox,
    LogTable,
    SchedulePicker,
    RelayCreateMultiBox,
    SvgIcon,
    SearchRow,
  },
})
export default class Boxes extends Vue {
  @Getter private currentUser: any;
  @Getter private envCompany: any;
  @Getter private isAdmin: boolean;
  @Getter private isMobile: boolean;
  @Getter private canDoInEnvCompany: (right: string) => boolean;

  @Prop()
  private readonly building: any;

  private boxes: any[] = [];
  private displayCreateMultiBox: boolean = false;
  private loading: boolean = false;
  private boxSearch: string = "";
  private typeOfBox: string = "";
  private mdiPlus = mdiPlus;
  private mdiQrcode = mdiQrcode;
  private page: number = 1;
  private totalItem: number = 10;
  private readonly getTokenLink = getTokenLink;

  // tslint:disable-next-line
  @Watch('boxSearch')
  public onBoxSearchChangeDebounced = debounce((newVal: string) => {
    this.reset();
  }, 500);

  get boxesHavQrCode(): boolean {
    return this.boxes.some((box) => !!box.qrCode);
  }

  get onlyConnectedBox(): boolean {
    return this.building ? !this.building?.Relays?.length : false;
  }

  get relaySubscriptionOptions(): {
    connectedBoxes: boolean,
    masterlocks: boolean,
    manageStock: boolean,
  } {
    return {
      connectedBoxes: this.isAdmin ? true : canUseFeature(this.envCompany, "connectedBoxes"),
      masterlocks: this.isAdmin ? true : canUseFeature(this.envCompany, "masterlocks"),
      manageStock: this.isAdmin ? true : canUseFeature(this.envCompany, "manageStock"),
    };
  }

  get hasEditRight(): boolean {
    return this.isAdmin ? true : this.canDoInEnvCompany("EDIT_BOX");
  }

  private mounted() {
    this.reset();
    this.initScroll();
  }

  private reset() {
    this.boxes = [];
    this.page = 1;
    this.getFullBoxes();
  }

  private async getFullBoxes(): Promise<void> {
    this.loading = true;
    return this.$store.dispatch(
      "buildings/getBoxes",
      {
        buildingId: this.building?.id,
        search: this.boxSearch,
        onlyConnected: this.typeOfBox === "CONNECTED",
        onlyNotConnected: this.typeOfBox === "NOT_CONNECTED",
        page: this.page,
        itemsPerPage: 8,
      },
    )
      .then((data) => {
        this.loading = false;
        this.totalItem = data.count || 0;
        if (this.page === 1) {
          this.boxes = data?.rows || [];
        } else {
          this.boxes = [...this.boxes, ...(data?.rows || [])];
        }
      }).finally(
        () => {
          this.$emit("loaded");
        },
      );
  }

  private openCreateMultiBox() {
    this.displayCreateMultiBox = true;
  }

  private closeCreateMultiBox(closeObject) {
    this.displayCreateMultiBox = false;
    if (closeObject.updateBoxes) {
      this.reset();
    }
  }

  /**
   * Resets the search page to 1 and retrieves the Build Bing List.
   *
   * @returns {void}
   */
  private searchHandler(event): void {
    this.boxSearch = event.search;
  }


  private initScroll(): void {
    window.addEventListener("scroll", async (): Promise<void> => {
      const listElm = document.querySelector("#box-list-container");
      const currentScrollValue: number = document.documentElement.scrollTop;
      const threshold: number = listElm?.clientHeight - window.innerHeight - 1000;
      const isTargetPos: boolean = currentScrollValue > threshold;
      if (isTargetPos && !this.loading && this.boxes.length < this.totalItem) {
        this.page++;
        await this.getFullBoxes();
      }
    });
  }
}

